const ExpandCollapseDetails = ({
  toggleAllAccordions,
  allAccordionsOpen,
  anyAccordionOpen,
}: {
  toggleAllAccordions: (isOpen: boolean) => void;
  allAccordionsOpen: boolean;
  anyAccordionOpen: boolean;
}) => {
  return (
    <>
      <div
        style={{
          padding: "24px 10px 24px 30px",
        }}
        className="show-for-small-only"
      >
        <div className="text-center">
          Need help Enrolling? Give us call.
          <br />
          <span
            className="color-primary"
            style={{ textDecoration: "underline", fontWeight: 600 }}
          >
            <a href="tel:18882938272">1-888-293-8272</a>(TTY: 711).
          </span>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            fontSize: 18,
            fontWeight: 600,
            alignItems: "center",
            justifyContent: "center",
            paddingTop: 24,
          }}
        >
          <div
            className="expand-all"
            style={{
              paddingRight: 32,
              borderRight: "3px solid #8A8A8A",
              color: !anyAccordionOpen
                ? "#1B54C2"
                : allAccordionsOpen
                ? "#8A8A8A "
                : "#1B54C2",
              cursor: !anyAccordionOpen
                ? "pointer"
                : allAccordionsOpen
                ? "not-allowed"
                : "pointer",
            }}
            onClick={() => toggleAllAccordions(true)}
          >
            Expand all
          </div>
          <div
            style={{
              paddingLeft: 32,
              color: anyAccordionOpen
                ? "#1B54C2"
                : !allAccordionsOpen
                ? "#8A8A8A "
                : "#1B54C2",
              cursor: anyAccordionOpen
                ? "pointer"
                : !allAccordionsOpen
                ? "not-allowed"
                : "pointer",
            }}
            onClick={() => toggleAllAccordions(false)}
          >
            Collapse all
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "24px 10px 24px 30px",
        }}
        className="hide-for-small-only"
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            fontSize: 18,
            fontWeight: 600,
            alignItems: "center",
          }}
        >
          <div
            className="expand-all"
            style={{
              paddingRight: 16,
              borderRight: "3px solid #8A8A8A",
              color: !anyAccordionOpen
                ? "#1B54C2"
                : allAccordionsOpen
                ? "#8A8A8A "
                : "#1B54C2",
              cursor: !anyAccordionOpen
                ? "pointer"
                : allAccordionsOpen
                ? "not-allowed"
                : "pointer",
            }}
            onClick={() => toggleAllAccordions(true)}
          >
            Expand all
          </div>
          <div
            style={{
              paddingLeft: 16,
              color: anyAccordionOpen
                ? "#1B54C2"
                : !allAccordionsOpen
                ? "#8A8A8A "
                : "#1B54C2",
              cursor: anyAccordionOpen
                ? "pointer"
                : !allAccordionsOpen
                ? "not-allowed"
                : "pointer",
            }}
            onClick={() => toggleAllAccordions(false)}
          >
            Collapse all
          </div>
        </div>
        <div className="text-right">
          Need help Enrolling? Give us call.
          <br />
          <span
            className="color-primary"
            style={{ textDecoration: "underline", fontWeight: 600 }}
          >
            <a href="tel:18882938272">1-888-293-8272</a>
          </span>{" "}
          (TTY: 711)
        </div>
      </div>
    </>
  );
};

export default ExpandCollapseDetails;
